import dayjs from 'dayjs';

export interface IOrder {
  id?: number;
  orderId?: string | null;
  date?: dayjs.Dayjs | null;
  deliveryDate?: dayjs.Dayjs | null;
  status?: string | null;
  totalAmount?: number;
  savingAmount?: number | null;
  promocode?: string | null;
  address?: string;
  cityId?: number;
  pincode?: number;
  shedule?: string;
  noofitems?: number | null;
  dcharges?: number | null;
  hcharges?: number | null;
  dvendor?: string;
  latitude?: string | null;
  logitude?: string | null;
  paymentStatus?: string;
  paymentType?: string;
  dtip?: number | null;
  vendorId?: string | null;
  vendorName?: string | null;
  mobile?: string;
  dmobile?: string | null;
  vmobile?: string | null;
  timing?: string | null;
}

export const defaultValue: Readonly<IOrder> = {};
